import React from 'react'
import SideBar from "../../components/AdminDashboard/SideBar";
import AdminAdsSection from '../../components/AdminDashboard/AdminAdsSection';
import AvertTable from '../../components/AdminDashboard/AvertTable';

function AdvertSection() {
  const AddIcon = ({ color = "#0D924F", size = 32 }) => (
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_5711_37047" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<path d="M28.5 1H3.5C2.11929 1 1 2.11929 1 3.5V28.5C1 29.8807 2.11929 31 3.5 31H28.5C29.8807 31 31 29.8807 31 28.5V3.5C31 2.11929 29.8807 1 28.5 1Z" fill="white" stroke="white" stroke-width="2" stroke-linejoin="round"/>
<path d="M15.9987 9.33398V22.6673M9.33203 16.0007H22.6654" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</mask>
<g mask="url(#mask0_5711_37047)">
<path d="M-4 -4H36V36H-4V-4Z" fill="#0D924F"/>
</g>
</svg>

);
const Draft = ({ color = "#0D924F", size = 32 }) => (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M33.3333 3.33398C33.7754 3.33398 34.1993 3.50958 34.5118 3.82214C34.8244 4.1347 35 4.55862 35 5.00065V11.2623L20.0017 26.2623L19.9917 33.3257L27.0683 33.3356L35 25.404V35.0007C35 35.4427 34.8244 35.8666 34.5118 36.1792C34.1993 36.4917 33.7754 36.6673 33.3333 36.6673H6.66667C6.22464 36.6673 5.80072 36.4917 5.48816 36.1792C5.17559 35.8666 5 35.4427 5 35.0007V5.00065C5 4.55862 5.17559 4.1347 5.48816 3.82214C5.80072 3.50958 6.22464 3.33398 6.66667 3.33398H33.3333ZM36.2967 14.6806L38.6533 17.0373L25.69 30.0007L23.33 29.9973L23.3333 27.644L36.2967 14.6806ZM20 20.0007H11.6667V23.334H20V20.0007ZM25 13.334H11.6667V16.6673H25V13.334Z" fill="#898989"/>
</svg>

);
const Posts = ({ color = "#0D924F", size = 32 }) => (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33203 18.3327V6.66602H36.6654V18.3327H3.33203ZM16.6654 33.3327V21.666H36.6654V33.3327H16.6654ZM3.33203 33.3327V21.666H13.332V33.3327H3.33203Z" fill="#FDA92B"/>
</svg>


);

   

  return (
    <div className="admin_history">
      <div className="sidebar_container ">
        <SideBar />
  
      </div>
      <div>

      <div className='mt-20 mb-10 ml-20 text-[24px] font-semibold'>Advert Section </div>
      <div className="  flex">

          <AdminAdsSection   icon={
    <div className=" rounded-full flex items-center justify-center text-white text-2xl">
      <AddIcon size={32} />
    </div>
  } 
  title = "Add New Post / News"
  subtitle = "Create and post new content,News, articles and others"
  link="/addPost"
/>
  
          <AdminAdsSection   icon={
    <div className=" rounded-full flex items-center justify-center text-white text-2xl">
  <Draft size={32} />
    </div>
  } 
  title = "Saved Drafts"
  subtitle = "Edit, schedule, save, publish and delete your drafts "

/>
          <AdminAdsSection   icon={
    <div className=" rounded-full flex items-center justify-center text-white text-2xl">
  <Posts size={32} />

    </div>
  } 
  title = "Views Posts"
  subtitle = "See all post based on categories, tags, date. "
  link="/viewPosts"

/>
      </div>
      <AvertTable/>

      </div>

    </div>
  )
}

export default AdvertSection